import React from 'react';

const Button = ({ 
  children, 
  type = "button", 
  onClick, 
  className = "",
  disabled = false,
  icon = null
}) => {
  return (
    <button 
      type={type}
      className={`w-full bg-[#61EA3C] text-black font-semibold py-2 rounded-[4px] hover:opacity-90 transition disabled:opacity-50 ${className}`}
      onClick={onClick}
      disabled={disabled}
    >
      {children}
      {icon && <img src={icon} alt="icon" className="h-4 w-4 sm:h-[18px] sm:w-[18px]"/>}
    </button>
  );
};

export default Button;